// Request will be proxied via /api/be/[...apiGateway].ts
const baseUrl = '/api/be';

export const BackendApiUrl = {
    test: baseUrl + '/api/test',
    registrationForm: baseUrl + '/api/v1/program-registration',
    getUserInfo: baseUrl + '/api/v1/user',
    updateUserEmail: baseUrl + '/api/v1/user/email',
    updateUserPassword: baseUrl + '/api/v1/user/password',
    updateUserDetail: baseUrl + '/api/v1/user/phone',
    updateUserProfile: baseUrl + '/api/v1/user/username',
    newsletterRegistration: baseUrl + '/api/v1/newsletter-registration',
    onlineCourseRegistration: baseUrl + '/api/v3/online-course-registration',
}
